// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import FieldView from '../utils/FieldView';
import Modal from '../utils/ModalComponet';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const CardDetailsView = ({ cardDetails, closeModal }) => (
  <Modal open closeModal={closeModal}>
    <h4>
      <b>Card Details</b>
    </h4>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    <FieldView name='Card number'>{cardDetails.number}</FieldView>
    <FieldView name='Expiration'>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {`${cardDetails.exp_month} / ${cardDetails.exp_year}`}
    </FieldView>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    <FieldView name='CVV'>{cardDetails.cvc}</FieldView>
  </Modal>
);

export default React.memo(CardDetailsView);
